import { render, staticRenderFns } from "./WidgetProductReviewsBoardPc.vue?vue&type=template&id=4efc9413&scoped=true"
import script from "./WidgetProductReviewsBoardPc.vue?vue&type=script&lang=js"
export * from "./WidgetProductReviewsBoardPc.vue?vue&type=script&lang=js"
import style0 from "./WidgetProductReviewsBoardPc.vue?vue&type=style&index=0&id=4efc9413&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efc9413",
  null
  
)

export default component.exports